import React from 'react'
import { Col, Card, Space, Typography, Tag, Progress } from 'antd'
import { TeamOutlined } from '@ant-design/icons'

const { Text } = Typography

const StaffOverview = ({ staffSummary }) => {
  return (
    <Col xs={24} md={8}>
      <Card
        title={
          <Space>
            <TeamOutlined /> Staff on Duty
          </Space>
        }
        size='small'
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Doctors</Text>
            <Space>
              <Tag color='blue'>
                {staffSummary.doctors.onDuty} / {staffSummary.doctors.total}
              </Tag>
              <Progress
                percent={Math.round((staffSummary.doctors.onDuty / staffSummary.doctors.total) * 100)}
                size='small'
                showInfo={false}
                strokeColor='#1890ff'
                style={{ width: 80 }}
              />
            </Space>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Nurses</Text>
            <Space>
              <Tag color='green'>
                {staffSummary.nurses.onDuty} / {staffSummary.nurses.total}
              </Tag>
              <Progress
                percent={Math.round((staffSummary.nurses.onDuty / staffSummary.nurses.total) * 100)}
                size='small'
                showInfo={false}
                strokeColor='#52c41a'
                style={{ width: 80 }}
              />
            </Space>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Specialists</Text>
            <Space>
              <Tag color='purple'>
                {staffSummary.specialists.onDuty} / {staffSummary.specialists.total}
              </Tag>
              <Progress
                percent={Math.round((staffSummary.specialists.onDuty / staffSummary.specialists.total) * 100)}
                size='small'
                showInfo={false}
                strokeColor='#722ed1'
                style={{ width: 80 }}
              />
            </Space>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Technicians</Text>
            <Space>
              <Tag color='orange'>8 / 12</Tag>
              <Progress percent={67} size='small' showInfo={false} strokeColor='#fa8c16' style={{ width: 80 }} />
            </Space>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Admin Staff</Text>
            <Space>
              <Tag color='cyan'>14 / 18</Tag>
              <Progress percent={78} size='small' showInfo={false} strokeColor='#13c2c2' style={{ width: 80 }} />
            </Space>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Support Staff</Text>
            <Space>
              <Tag color='gold'>11 / 15</Tag>
              <Progress percent={73} size='small' showInfo={false} strokeColor='#faad14' style={{ width: 80 }} />
            </Space>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Paramedics</Text>
            <Space>
              <Tag color='magenta'>6 / 9</Tag>
              <Progress percent={67} size='small' showInfo={false} strokeColor='#eb2f96' style={{ width: 80 }} />
            </Space>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Pharmacists</Text>
            <Space>
              <Tag color='geekblue'>4 / 6</Tag>
              <Progress percent={67} size='small' showInfo={false} strokeColor='#2f54eb' style={{ width: 80 }} />
            </Space>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text>Radiologists</Text>
            <Space>
              <Tag color='volcano'>5 / 7</Tag>
              <Progress percent={71} size='small' showInfo={false} strokeColor='#f5222d' style={{ width: 80 }} />
            </Space>
          </div>
        </Space>
      </Card>
    </Col>
  )
}

export default StaffOverview
